<template>
    <span class="icon-spinner animate-spin"></span>
</template>

<script>
    export default {
        name: "Spinner"
    }
</script>